let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("azoml")).then(() => parcelRequire('4McjS'));